<div class="w-full bg-white flex flex-wrap text-gray-700">
  <div
    class="flex-3 flex items-center p-4 border-r border-gray-100 min-w-[200px]"
  >
    <div class="text-primary flex items-center justify-center">
      <ng-icon name="bootstrapSearch" class="ml-2" size="20" />
    </div>
    <input
      type="text"
      [(ngModel)]="textFilter"
      placeholder="Buscar empleo..."
      class="ml-2 border px-4 py-2 w-full border-transparent focus:outline-none focus:ring-2 focus:ring-transparent"
      (keyup.enter)="buscarEmpleos()"
    />
  </div>
  <div
    class="hidden md:flex flex-2 items-center gap-2 py-4 px-3 border-r border-gray-100"
  >
    <app-select-single
      [options]="locations"
      [placeholder]="'Ubicación'"
      [icon]="'bootstrapPinMap'"
      [addNewOption]="false"
      (select)="onSeleccionado($event, 'location')"
    />
  </div>
  <div
    class="hidden lg:flex flex-2 items-center justify-center gap-2 py-4 px-3 border-r border-gray-100"
  >
    <app-select-single
      [options]="typeJobs"
      [placeholder]="'Tipo de trabajo'"
      [icon]="'bootstrapSuitcaseLg'"
      [addNewOption]="false"
      (select)="onSeleccionado($event, 'jobType')"
    />
  </div>
  <div
    class="hidden xl:flex flex-2 items-center justify-center gap-2 py-4 px-3 border-r border-gray-100"
  >
    <app-select-single
      [options]="salaryRanges"
      [placeholder]="'Seleccione un salario'"
      [addNewOption]="true"
      (select)="onSeleccionado($event, 'salary')"
    />
  </div>
  <div class="flex-1 p-3 min-w-[120px]">
    <button
      (click)="buscarEmpleos()"
      class="bg-primary w-full h-full text-white px-4 py-2 rounded-sm cursor-pointer transform transition-all duration-300 ease-out hover:scale-105 hover:shadow-lg active:scale-95"
    >
      Buscar
    </button>
  </div>
</div>
